/**
 * @class SpectralData
 */
export default class SpectralData {
    /**
     * @param {Array}   rgb
     * @param {Array}   lab
     * @param {Array}   xyz
     * @param {String}  rgbHex
     * @param {Array}   spectral
     * @param {String}  image
     */
    constructor(rgb, lab, xyz, rgbHex, spectral = null, image = null) {
        this._rgb = rgb;
        this._lab = lab;
        this._xyz = xyz;
        this._rgbHex = rgbHex;
        this._spectral = spectral;
        this._image = image;
    }

    /**
     * @return {Array}
     */
    get rgb() {
        return this._rgb;
    }

    /**
     * @param {Array}   rgb
     */
    set rgb(rgb) {
        this._rgb = rgb;
    }

    /**
     * @return {Array}
     */
    get lab() {
        return this._lab;
    }

    /**
     * @param {Array}   lab
     */
    set lab(lab) {
        this._lab = lab;
    }

    /**
     * @return {Array}
     */
    get xyz() {
        return this._xyz;
    }

    /**
     * @param {Array}   xyz
     */
    set xyz(xyz) {
        this._xyz = xyz;
    }

    /**
     * @return {String}
     */
    get rgbHex() {
        return this._rgbHex;
    }

    /**
     * @param {String}  rgbHex
     */
    set rgbHex(rgbHex) {
        this._rgbHex = rgbHex;
    }

    /**
     * @return {Array}
     */
    get spectral() {
        return this._spectral;
    }

    /**
     * @param {Array}   spectral
     */
    set spectral(spectral) {
        this._spectral = spectral;
    }

    /**
     * @return {String}
     */
    get image() {
        return this._image;
    }

    /**
     * @param {String}  image
     */
    set image(image) {
        this._image = image;
    }

    /**
     * @returns {boolean}
     */
    isLabValid = () => {
        return Array.isArray(this._lab) && this._lab.length === 3;
    };
}
